import React from 'react';

export function GridOverlay() {
  return (
    <div className="fixed z-30 inset-0 pointer-events-none">
      <div className="deck h-full flex ">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(x => (
          <div className="h-full w-col-1 bg-play-purple/30 z-[2000]"></div>
        ))}
      </div>
    </div>
  );
}
